<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @exps="exps"  @search="search" @reflash="reflash" @export="exps" ref="SetBtn"></buttonlist>
		<!-- <el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-button type="primary" size="mini"  @click="send">获取数据</el-button>
				</div>
			</div>
		</el-card> -->
			<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px">
				<wTable
						id="xpane-0"
						:data="dataSet"
						:loading="loading"
						queryData="MonthIssueInfoEx"
						:filter_thousandth="['issue_qty','issue_material_unit','issue_man_unit','issue_charge_unit','issue_material_amount','issue_man_amount','issue_charge_amount']"
						:header="tableHeader"
						:option="tableOption"
						ref="singleTable"
						:checkflg="false"
				></wTable>
			<!--<el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true" 
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			>
<el-table-column show-overflow-tooltip prop="cost_year" :label="$t('getapi[1974]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="cost_month" :label="$t('getapi[1975]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="category_first" :label="$t('getapi[169]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="category_second" :label="$t('getapi[170]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="category_third" :label="$t('getapi[171]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[2000]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[2001]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="part_master_unit" :label="$t('getapi[4590]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_time" :label="$t('getapi[4826]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="digest" :label="$t('getapi[7340]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_person" :label="$t('getapi[2289]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4473]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_dept_code" :label="$t('getapi[7794]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_dept_name" :label="$t('getapi[7795]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="picker" :label="$t('getapi[7546]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[2206]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[3868]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_qty" :label="$t('getapi[2207]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_material_unit" :label="$t('getapi[7796]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_man_unit" :label="$t('getapi[7797]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_charge_unit" :label="$t('getapi[7798]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_material_amount" :label="$t('getapi[7481]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_man_amount" :label="$t('getapi[7482]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_charge_amount" :label="$t('getapi[7483]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')" ></el-table-column>
			</el-table> -->

				<!--show-overflow  省略号 <vxe-table
					:data="dataSet"
					v-loading="loading"
					border
					stripe
					resizable
					size="mini"
					:height="tableHeight"
				>

				<vxe-table-column show-overflow-tooltip field="part_code" :title="$t('getapi[112]')" width='100'/>
				<vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[149]')" width='100'/>
				<vxe-table-column show-overflow-tooltip field="part_master_unit" title="计量单位" width='100'/>
				<vxe-table-column show-overflow field="part_name" title="物料名称" width='150' />

				<vxe-table-column show-overflow-tooltip field="vender_count" title="报价供应商数量" width='150' align="right"/>
				<vxe-table-column show-overflow-tooltip field="sum_net_unit" title="合计不含税单价" width='150' align="right"/>
				<vxe-table-column show-overflow-tooltip field="sum_unit" title="合计含税单价" width='150' align="right"/>
				<vxe-table-column show-overflow-tooltip field="avg_net_unit" title="平均不含税单价" width='150' align="right"/>
				<vxe-table-column show-overflow-tooltip field="avg_unit" title="平均含税单价" width='150' align="right"/> -->

				<!-- </vxe-table> -->
			
			</li>
		</ul>
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="MonthIssueInfoEx" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[6657]')" queryData="MonthIssueInfoEx" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
		<!-- 改变表格顺序 -->
		<!-- <ctable :isVisible="false" title="CSV" queryData="SalLogicticscsvViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable> -->
	
	
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_splitmonth',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			viewurl:'/CostCalc/InvView/GetSalDetailViewEx',
			expurl:'/CostCalc/InvView/GetSalDetailViewExToExecl',
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('3_splitmonth'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				//拷贝
				send: false,
				print:false,
				//删除
				delete: false,
			},
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	mounted: function() {
		let that = this;
        that.colsort();
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		

	},
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('MonthIssueInfoEx',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6657]"),this.$t("getapi[6633]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
			let limits=1;
			//that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);

			//that.$refs.SetBtn.SetButtonEnable('export',true);
			that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			return;

			// //只读权
			// if (that.$limits.ReadOnlyRightsView('plv2', 375, 1, that.total)) {
			// 	if (that.total > 0) {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 	} else {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 	}
			// }
			// //操作权限-查询级别
			// limits = that.$limits.OperationAuthorityView('plv2', 375, 1, that.total);
			// // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			// switch (limits) {
			// 	case -1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	default:
			// 		break;
			// }
			// if(limits==-1||limits==1)that.closeAllRightButton();
            // else that.btnauthority();
		},
		btnauthority() {
			let that = this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
			
		},
		closeAllRightButton(){
			let that =this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		},
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange(val) {
		let that = this;
		that.selectIDList=val;
		if(that.selectIDList.length>0){
			that.btn.send = true;
			that.btn.delete = true;
			that.btn.print = true;
		}else{
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		}
		},
		
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('3_splitmonth',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'MonthIssueInfoEx');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost(that.viewurl, data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		//按月拷贝成本
		copy(){
			let that = this;
			that.dialogVisible = true;
			
		},
		copyconfirm(){
			//  
			let that = this;
			that.btn.copy = false
			let parm = {
			"newmonth": that.copyparam.copyMonth.split("-")[1],
			"newyear": that.copyparam.copyMonth.split("-")[0],
			"oldmonth": that.copyparam.startMonth.split("-")[1],
			"oldyear": that.copyparam.startMonth.split("-")[0],
			}

			that.$http.urlpost('/Inv/PartCost/InvPartStdCostCopyCost', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
				that.btn.copy = true;
				that.dialogVisible = false;
			});


		},
		send(){
			let that = this;
			that.loading = true;
			that.$http.urlpost('/CostCalc/PurView/GetLatestPurPriceView', {}, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
				}
				that.loading = false;
			});
		},
		print(){
			let that = this;
			let parm = {
			po_no: '',
			TemplateName: '08Invoice_CSV.xlsx'
			};

			for(let i=0;i<that.selectIDList.length;i++){
			parm.po_no= parm.po_no + "'"+that.selectIDList[i].exclusively_id+"',";
			}
			parm.po_no =  parm.po_no.substring(0, parm.po_no.length - 1);

			that.btn.print = false;
			that.loading = true;
			that.$http.urlpost('/Print/CSVPrint', parm, function (res) {
			that.btn.print = true;
			if (res.Success == 1) {
			let hrefurl = res.Key;
			window.open(hrefurl);
			} 
			that.loading = false;
			});
		},
		deleteline(){
			let that = this;
			let parm = {
				Delivery_Note_N: that.selectIDList[0].Delivery_Note_N,
			};
			that.$http.urlpost('/Sal/Tru/DeleteCsv', parm, function(res) {
				if (res.Success == 1) {
					that.reflash();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
				}
			});

		},
		// 导出
		exps() {
			/*let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost(that.expurl, data, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "MonthIssueInfoEx",
                fromname: that.$t('getapi[6657]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
